import { useState } from "react";
import { InputAdornment } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import cn from "classnames";
import { useAppDispatch } from "@/store/hooks";
import { changePhraseActivatorMessengerConnector, deletePhraseActivatorMessengerConnector } from "@/store/ses/sesConnectorSlice";
import { useTranslate } from "@/hooks";
import { colorRed } from "@/constants/colors";
import { CustomTextField } from "@/ui";
import { IActivatorProps } from "./Activator.props";
import styles from "./Activator.module.scss";

const Activator = ({ channel, phrase, idx, array, changeFlgHandler, isDisabled }: IActivatorProps): JSX.Element => {
	const [inputPhrase, setInputPhrase] = useState<string>(phrase); // фраза-активатор

	const dispatch = useAppDispatch();

	const translate = useTranslate(); // hook для перевода текста

	// обработчик изменения фразы-активатора
	const activatorPhraseChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
		if (array.length - 1 === idx) dispatch(changePhraseActivatorMessengerConnector({ channel, phraseIdx: idx, phrase: inputPhrase }));
		setInputPhrase(e.target.value);
	};

	// обработчик сохранения фразы-активатора
	const activatorPhraseSaveHandler = (): void => {
		if (phrase === inputPhrase) return;
		dispatch(changePhraseActivatorMessengerConnector({ channel, phraseIdx: idx, phrase: inputPhrase }));
		changeFlgHandler("params");
	};

	// обработчик удаления фразы-активатора
	const phraseDeletionHandler = (): void => {
		dispatch(deletePhraseActivatorMessengerConnector({ channel, phraseIdx: idx }));
		changeFlgHandler("params");
	};

	return (
		<div
			className={cn(styles.activator, {
				[styles.activatorOpacity]: array.length - 1 === idx,
				[styles.activatorHidden]: array.length - 1 === idx && isDisabled,
			})}
		>
			<CustomTextField
				fullWidth
				placeholder={translate("input_addPhrase")}
				value={inputPhrase}
				onChange={activatorPhraseChangeHandler}
				onBlur={activatorPhraseSaveHandler}
				error={!inputPhrase && array.length - 1 !== idx}
				disabled={isDisabled}
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							{!isDisabled && array.length > 1 && array.length - 1 !== idx && (
								<div className={styles.deletePhraseButton}>
									<FontAwesomeIcon
										icon={faTrashCan}
										color={colorRed}
										size="sm"
										onClick={phraseDeletionHandler}
										title={translate("button_deletePhrase")}
										style={{ cursor: "pointer" }}
									/>
								</div>
							)}
						</InputAdornment>
					),
				}}
			/>
		</div>
	);
};

export default Activator;
